import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalysisBatchesQuery } from '../../hooks/useDealstackAiQueries';
import { toBatchListItem } from './batchList.utils';
import type { DealBatchesMenuController } from './useDealBatchesMenuController.types';

/** The deal's DealStack AI batches, newest first, for the Transactions tab's entry menu. */
export const useDealBatchesMenuController = (dealId: string): DealBatchesMenuController => {
	const navigate = useNavigate();
	const batches = useAnalysisBatchesQuery(dealId);

	const items = useMemo(
		() => batches.data?.batches.map((batch) => toBatchListItem(dealId, batch)),
		[batches.data, dealId]
	);

	return {
		items,
		openBatch: ({ path }) => {
			if (path !== null) {
				navigate(path);
			}
		},
	};
};
